const ta = {
    "gui.menuBar.file": "கோப்பு",
    "gui.menuBar.edit": "திருத்து",
    "gui.menuBar.new": "புதியது",
    "gui.menuBar.saveNow": "இப்போது சேமி",
    "gui.menuBar.saveAsCopy": "நகலாக சேமி",
    "gui.menuBar.remix": "ரீமிக்ஸ்",
    "gui.menuBar.languageSelector": "மொழி தேர்வி",
    "gui.menuBar.tutorialsLibrary": "பயிற்சிகள்",
    "gui.menuBar.community": "சமூகம்",
    "gui.menuBar.wiki": "பதிவிறக்க முகவர்",
    "gui.menuBar.restoreSprite": "ஸ்ப்ரைட்டை மீட்டமை",
    "gui.menuBar.restoreSound": "ஒலியை மீட்டமை",
    "gui.menuBar.restoreCostume": "உடையை மீட்டமை",
    "gui.menuBar.restore": "மீட்டமை",
    "gui.menuBar.turboModeOff": "டர்போ பயன்முறையை நிறுத்து",
    "gui.menuBar.turboModeOn": "டர்போ பயன்முறையை இயக்கு",
    "gui.menuBar.noDeviceSelected": "சாதனம் தேர்ந்தெடுக்கப்படவில்லை",
    "gui.menuBar.noConnection": "இணைப்பு இல்லை",
    "gui.menuBar.downloadToComputer": "கணினியில் பதிவிறக்கு",
    "gui.menuBar.checkUpdate": "புதுப்பிப்பை சரிபார்",
    "gui.menuBar.installDriver": "இயக்கியை நிறுவு",
    "gui.menuBar.clearCacheAndRestart": "கேசை அழித்து மீண்டும் தொடங்கு",
    "gui.adblockModal.title": "விளம்பரத் தடுப்பான் கண்டறியப்பட்டது",
    "gui.adblockModal.body":
        "TIFStudio விளம்பரத் தடுப்பானால் தடுக்கப்படுகிறது. TIFStudio-க்கு விளம்பரத் தடுப்பானை முடக்கவும்.",
    "gui.adblockModal.reload": "மீண்டும் ஏற்று",
    "gui.alerts.createsuccess": "புதிய திட்டம் உருவாக்கப்பட்டது.",
    "gui.alerts.createcopysuccess": "திட்டம் நகலாக சேமிக்கப்பட்டது.",
    "gui.alerts.createremixsuccess": "திட்டம் ரீமிக்ஸாக சேமிக்கப்பட்டது.",
    "gui.alerts.creating": "புதியதை உருவாக்குகிறது...",
    "gui.alerts.creatingCopy": "திட்டத்தின் நகலை உருவாக்குகிறது...",
    "gui.alerts.creatingRemix": "திட்டத்தின் ரீமிக்ஸை உருவாக்குகிறது...",
    "gui.alerts.downloading": "பதிவிறக்குகிறது...",
    "gui.alerts.loading": "ஏற்றுகிறது...",
    "gui.alerts.saving": "சேமிக்கிறது...",
    "gui.alerts.savesuccess": "திட்டம் சேமிக்கப்பட்டது.",
    "gui.alerts.savingError": "திட்டத்தை சேமிக்க முடியவில்லை.",
    "gui.alerts.cloudInfo":
        "கவனிக்கவும், கிளவுட் மாறிகள் எண்களை மட்டுமே ஆதரிக்கும், எழுத்துகள் அல்லது சின்களை அல்ல.",
    "gui.alerts.cloudVariableFull": "கிளவுட் மாறி வரம்பு எட்டப்பட்டது.",
    "gui.alerts.importedSvgTitle": "பதிவேற்றப்பட்ட SVG கோப்பில் சிக்கல்",
    "gui.alerts.importedSvgMessage":
        "SVG கோப்பை ஏற்ற முடியவில்லை. இது சரியான SVG கோப்பா?",
    "gui.alerts.importedSvgReset": "மீண்டும் முயற்சி",
    "gui.alerts.importedSvgCancel": "ரத்து",
    "gui.alerts.uploadError": "பதிவேற்ற தவறு",
    "gui.alerts.uploadSuccess": "பதிவேற்றம் வெற்றி",
    "gui.gui.addExtension": "நீட்சியைச் சேர்",
    "gui.gui.code": "குறியீடு",
    "gui.gui.backdrops": "பின்னணிகள்",
    "gui.gui.costumes": "உடைகள்",
    "gui.gui.sounds": "ஒலிகள்",
    "gui.gui.codeTab": "குறியீடு",
    "gui.gui.costumesTab": "உடைகள்",
    "gui.gui.backdropsTab": "பின்னணிகள்",
    "gui.gui.soundsTab": "ஒலிகள்",
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.menuBar.turnOffCamera": "கேமராவை அணை",
    "gui.menu-bar.realtimeMode": "ஸ்க்ராட்ச்",
    "gui.menu-bar.programMode": "போர்க்கோர்",
    "gui.hardwareConsole.send": "அனுப்பு",
    "gui.hardwareConsole.buadrate": "பாட் வீதம்",
    "gui.hardwareConsole.endOfLine": "வரி முடிவு",
    "gui.hardwareConsole.hexform": "ஹெக்ஸ் வடிவம்",
    "gui.hardwareConsole.autoScroll": "தானியங்கு உருள்",
    "gui.hardwareHeader.upload": "பதிவேற்று",
    "gui.stageHeader.codeStageSizeLarge": "பெரிய மேடை",
    "gui.stageHeader.codeStageSizeSmall": "சிறிய மேடை",
    "gui.stageHeader.hideStage": "மேடையை மறை",
    "gui.stageHeader.fullscreenControl": "முழுத்திரை கட்டுப்பாடு",
    "gui.extensionLibrary.comingSoon": "விரைவில் வருகிறது",
    "gui.extensionLibrary.requires": "தேவை",
    "gui.extensionLibrary.collaboration": "இணைந்து",
    // Extension Library Metadata
    "gui.extensionLibrary.manufactor": "உற்பத்தியாளர்",
    "gui.extensionLibrary.version": "பதிப்பு",
    "gui.extensionLibrary.author": "लेखகர்",
    "gui.extensionLibrary.programMode": "நிரல் பயன்முறை",
    "gui.extensionLibrary.programLanguage": "நிரல் மொழி",
    "gui.extensionLibrary.deviceLearnMore": "மேலும் அறிய",
    "gui.extensionLibrary.extensionHelp": "உதவி",
    "gui.extensionLibrary.Processing": "செயலாக்கப்படுகிறது...",
    "gui.extensionLibrary.loaded": "ஏற்றப்பட்டது",
    "gui.extensionLibrary.notLoaded": "ஏற்றப்படவில்லை",
    "gui.extensionLibrary.chooseAnExtension": "ஒரு நீட்டிப்பைத் தேர்ந்தெடு",
    "gui.library.filterPlaceholder": "தேடு",
    "gui.library.allTag": "அனைத்தும்",
    "gui.library.readMore": "மேலும் படிக்க",
    "gui.library.readLess": "குறைவாகப் படிக்க",
    "gui.loader.message1": "ஸ்ப்ரைட்டுகளை உருவாக்குகிறது...",
    "gui.loader.message2": "ஒலிகளை ஏற்றுகிறது...",
    "gui.loader.message3": "உடைகளை ஏற்றுகிறது...",
    "gui.loader.message4": "நீட்சிகளை ஏற்றுகிறது...",
    "gui.loader.message5": "பிளாக்குகளை உருவாக்குகிறது...",
    "gui.loader.message6": "கணிதம் செய்கிறது...",
    "gui.loader.message7": "ஏற்றுகிறது...",
    "gui.loader.message8": "தயாராக்குகிறது...",
    "gui.loader.headline": "திட்டத்தை ஏற்றுகிறது",
    "gui.loader.creating": "திட்டத்தை உருவாக்குகிறது",
    "gui.spriteLibrary.chooseASprite": "ஒரு ஸ்ப்ரைட் தேர்ந்தெடு",
    "gui.spriteLibrary.paintASprite": "வரை",
    "gui.spriteLibrary.uploadASprite": "ஸ்ப்ரைட் பதிவேற்று",
    "gui.spriteLibrary.surprise": "ஆச்சரியம்",
    "gui.soundLibrary.chooseASound": "ஒரு ஒலியைத் தேர்ந்தெடு",
    "gui.soundLibrary.record": "பதிவு செய்",
    "gui.soundLibrary.uploadASound": "ஒலி பதிவேற்று",
    "gui.costumeLibrary.chooseACostume": "ஒரு உடையைத் தேர்ந்தெடு",
    "gui.costumeLibrary.paintACostume": "வரை",
    "gui.costumeLibrary.uploadACostume": "உடை பதிவேற்று",
    "gui.backdropLibrary.chooseABackdrop": "ஒரு பின்னணியைத் தேர்ந்தெடு",
    "gui.backdropLibrary.paintABackdrop": "வரை",
    "gui.backdropLibrary.uploadABackdrop": "பின்னணி பதிவேற்று",
    "gui.spriteSelector.addSpriteFromLibrary": "ஒரு ஸ்ப்ரைட் தேர்ந்தெடு",
    "gui.spriteSelector.addSpriteFromPaint": "வரை",
    "gui.spriteSelector.addSpriteFromSurprise": "ஆச்சரியம்",
    "gui.spriteSelector.addSpriteFromFileUpload": "ஸ்ப்ரைட் பதிவேற்று",
    "gui.stageSelector.addBackdropFromLibrary": "ஒரு பின்னணியைத் தேர்ந்தெடு",
    "gui.stageSelector.addBackdropFromPaint": "வரை",
    "gui.stageSelector.addBackdropFromSurprise": "ஆச்சரியம்",
    "gui.stageSelector.addBackdropFromFileUpload": "பின்னணி பதிவேற்று",
    "gui.stageSelector.stage": "மேடை",
    "gui.stageSelector.backdrops": "பின்னணிகள்",
    "gui.spriteSelectorItem.contextMenuDuplicate": "நகல் உருவாக்கு",
    "gui.spriteSelectorItem.contextMenuExport": "ஏற்றுமதி",
    "gui.spriteSelectorItem.contextMenuDelete": "நீக்கு",
    "gui.spriteInfo.sprite": "ஸ்ப்ரைட்",
    "gui.spriteInfo.size": "அளவு",
    "gui.spriteInfo.show": "காட்டு",
    "gui.spriteInfo.changeSize": "அளவு மாற்று",
    "gui.spriteInfo.changeX": "X மாற்று",
    "gui.spriteInfo.changeY": "Y மாற்று",
    "gui.spriteInfo.direction": "திசை",
    "gui.spriteInfo.changeDirection": "திசை மாற்று",
    "gui.spriteInfo.isVisible": "தெரிகிறது",
    "gui.deviceLibrary.chooseADevice": "ஒரு சாதனத்தைத் தேர்ந்தெடு",
    "gui.deviceLibrary.deviceUrl": "சாதன URL-ஐ உள்ளிடு",
    "gui.deviceLibrary.arduinoTag": "அர்டுயினோ",
    "gui.deviceLibrary.microbitTag": "மைக்ரோ:பிட்",
    "gui.deviceLibrary.esp32Tag": "ESP32",
    "gui.deviceLibrary.kitTag": "கிட்",
    "gui.deviceLibrary.shieldTag": "கவசம்",
    "gui.playButton.play": "இயக்கு",
    "gui.playButton.stop": "நிறுத்து",
    "gui.gui.variableScopeOptionAllSprites": "அனைத்து ஸ்ப்ரைட்களுக்கும்",
    "gui.gui.variableScopeOptionSpriteOnly": "இந்த ஸ்ப்ரைட்டுக்கு மட்டும்",
    "gui.gui.cloudVariableOption": "கிளவுட் மாறி (சர்வரில் சேமிக்கப்பட்டது)",
    "gui.gui.variablePromptDefaultValue": "என் மாறி",
    "gui.gui.listVariable": "பட்டியல் ஒன்றை உருவாக்கு",
    "gui.gui.makeAVariable": "மாறி ஒன்றை உருவாக்கு",
    "gui.gui.newVariable": "புதிய மாறி",
    "gui.soundEditor.sound": "ஒலி",
    "gui.soundEditor.play": "இயக்கு",
    "gui.soundEditor.stop": "நிறுத்து",
    "gui.soundEditor.copy": "நகல்",
    "gui.soundEditor.paste": "ஒட்டு",
    "gui.soundEditor.copyToNew": "புதியதில் நகல்",
    "gui.soundEditor.delete": "நீக்கு",
    "gui.soundEditor.save": "சேமி",
    "gui.soundEditor.undo": "முன்செயல் நீக்கு",
    "gui.soundEditor.redo": "மீண்டும் செய்",
    "gui.soundEditor.faster": "வேகமாக",
    "gui.soundEditor.slower": "மெதுவாக",
    "gui.soundEditor.echo": "எதிரொலி",
    "gui.soundEditor.robot": "ரோபோ",
    "gui.soundEditor.louder": "உரக்க",
    "gui.soundEditor.softer": "மென்மையாக",
    "gui.soundEditor.reverse": "தலைகீழ்",
    "gui.soundEditor.fadeOut": "மங்குதல் வெளியே",
    "gui.soundEditor.fadeIn": "மங்குதல் உள்ளே",
    "gui.soundEditor.mute": "ஒலி நீக்கு",
    "paint.paintEditor.hue": "நிறம்",
    "paint.paintEditor.saturation": "செறிவு",
    "paint.paintEditor.brightness": "பிரகாசம்",
    "paint.paintEditor.fill": "நிரப்பு",
    "paint.paintEditor.costume": "உடை",
    "paint.paintEditor.group": "குழுவாக்கு",
    "paint.paintEditor.ungroup": "குழு நீக்கு",
    "paint.paintEditor.undo": "முன்செயல் நீக்கு",
    "paint.paintEditor.redo": "மீண்டும் செய்",
    "paint.paintEditor.forward": "முன்னால் கொண்டுவா",
    "paint.paintEditor.backward": "பின்னால் அனுப்பு",
    "paint.paintEditor.front": "மிக முன்னால்",
    "paint.paintEditor.back": "மிக பின்னால்",
    "paint.paintEditor.more": "மேலும்",
    "paint.modeTools.brushSize": "தூரிகை அளவு",
    "paint.modeTools.eraserSize": "அழிப்பான் அளவு",
    "paint.modeTools.copy": "நகல்",
    "paint.modeTools.paste": "ஒட்டு",
    "paint.modeTools.delete": "நீக்கு",
    "paint.modeTools.curved": "வளைவு",
    "paint.modeTools.pointed": "கூர்முனை",
    "paint.modeTools.thickness": "தடிமன்",
    "paint.modeTools.flipHorizontal": "கிடைமட்ட புரட்டு",
    "paint.modeTools.flipVertical": "செங்குத்து புரட்டு",
    "paint.modeTools.filled": "நிரப்பப்பட்ட",
    "paint.modeTools.outlined": "வரம்பு",
    "paint.paintEditor.bitmap": "பிட்மேப்பாக மாற்று",
    "paint.paintEditor.vector": "வெக்டராக மாற்று",
    "paint.paintEditor.stroke": "வரம்பு",
    "paint.brushMode.brush": "தூரிகை",
    "paint.eraserMode.eraser": "அழிப்பான்",
    "paint.fillMode.fill": "நிரப்பு",
    "paint.lineMode.line": "கோடு",
    "paint.ovalMode.oval": "நீள்வட்டம்",
    "paint.rectMode.rect": "செவ்வகம்",
    "paint.reshapeMode.reshape": "வடிவமைப்பு மாற்று",
    "paint.roundedRectMode.roundedRect": "வட்டமான செவ்வகம்",
    "paint.selectMode.select": "தேர்ந்தெடு",
    "paint.textMode.text": "உரை",
    "paint.colorPicker.swap": "மாற்று",
    "gui.uploadProgress.uploading": "பதிவேற்றுகிறது",
    "gui.uploadProgress.uploadSuccess": "பதிவேற்றம் வெற்றி",
    "gui.uploadProgress.uploadError": "பதிவேற்ற தவறு",
    "gui.uploadProgress.close": "மூடு",
    "gui.uploadProgress.abort": "ரத்து செய்",
    "gui.connection.connect": "இணை",
    "gui.connection.disconnect": "துண்டி",
    "gui.connection.connected": "இணைக்கப்பட்டது",
    "gui.connection.connecting": "இணைக்கிறது...",
    "gui.connection.error": "பிழை",
    "gui.connection.unavailable": "கிடைக்கவில்லை",
    "gui.connection.noDevicesFound": "சாதனங்கள் எதுவும் கிடைக்கவில்லை",
    "gui.connection.scanning": "தேடுகிறது...",
    "gui.connection.help": "உதவி",
    "gui.connection.refresh": "புதுப்பி",
    "blockly.deleteBlock": "பிளாக்கை நீக்கு",
    "blockly.duplicateBlock": "நகல் உருவாக்கு",
    "blockly.addComment": "கருத்தைச் சேர்",
    "blockly.removeComment": "கருத்தை நீக்கு",
    "blockly.externalInput": "வெளி உள்ளீடு",
    "blockly.inlineInput": "உள்ளமை உள்ளீடு",
    "blockly.disableBlock": "பிளாக்கை முடக்கு",
    "blockly.enableBlock": "பிளாக்கை இயக்கு",
    "blockly.expandBlock": "பிளாக்கை விரிவாக்கு",
    "blockly.collapseBlock": "பிளாக்கை சுருக்கி",
    "blockly.help": "உதவி",
    "blockly.undo": "முன்செயல் நீக்கு",
    "blockly.redo": "மீண்டும் செய்",
    "blockly.cleanUp": "பிளாக்குகளை ஒழுங்குபடுத்து",
    "blockly.sortByCategory": "வகைப்படி வரிசைப்படுத்து",
    "blockly.workspaceComment": "பணியிடக் கருத்து",
    "blockly.exportToHtml": "HTML ஆக ஏற்றுமதி செய்",
    "blockly.snapToGrid": "கட்டத்தில் ஒட்டு",
    "blockly.cannotDeleteVariable": "இந்த மாறியை நீக்க முடியாது",
    "blockly.renameVariable": "மாறியின் பெயரை மாற்று",
    "blockly.newVariable": "புதிய மாறி",
    "blockly.renameVariableTitle": 'அனைத்து "%1" மாறிகளின் பெயரை மாற்று:',
    "blockly.variableAlreadyExists": '"%1" என்ற பெயரில் மாறி ஏற்கனவே உள்ளது',

    // Device translations
    "gui.device.unselectDevice.name": "சாதனத்தைத் தேர்வு நீக்கு",
    "gui.device.unselectDevice.description":
        "சாதனத்தைத் தேர்வு நீக்கி, தூய நிகழ்நேர நிரலாக்க பயன்முறைக்குத் திரும்பு.",
    "gui.device.connectingMessage": "இணைக்கிறது",
    "gui.device.arduinoUno.description":
        "எலக்ட்ரானிக்ஸ் மற்றும் கோடிங் தொடங்குவதற்கு சிறந்த போர்டு.",
    "gui.device.arduinoNano.description":
        "உங்கள் திட்டங்களை உருவாக்க Arduino Nano ஒரு சிறிய கிளாசிக் போர்டு.",
    "gui.device.arduinoLeonardo.description":
        "மவுஸ் அல்லது கீபோர்டாக செயல்படக்கூடிய கிளாசிக் Arduino போர்டு.",
    "gui.device.arduinoMega2560.description":
        "54 டிஜிட்டல் பின்கள், 16 அனலாக் இன்புட்கள் மற்றும் 4 சீரியல் போர்ட்கள் கொண்ட 8-பிட் போர்டு.",
    "gui.device.arduinoUnoR4Minima.description":
        "மேம்பட்ட செயல்திறன் மற்றும் நினைவகம், இருக்கும் ஷீல்டுகள் மற்றும் ஆப்ஷன்களுடன் இணக்கமாக உள்ளது.",
    "gui.device.arduinoUnoR4Wifi.description":
        "Wi-Fi மற்றும் Bluetooth இணைப்பு, 12x8 LED மேட்ரிக்ஸ் ஆன்-போர்டு.",
    "gui.device.esp32.description":
        "Wi-Fi மற்றும் Bluetooth கொண்ட பல செயல்பாடுகள் கொண்ட கட்டுப்பாட்டு போர்டு.",
    "gui.device.esp32S3.description":
        "AI முடுக்கி மற்றும் பல புற சாதனங்களுடன் ஒருங்கிணைந்த IoT மற்றும் AI பணிகளுக்கு.",
    "gui.device.esp8266NodeMCU.description":
        "குறைந்த விலை Wi-Fi SOC கட்டுப்பாட்டு போர்டு.",
    "gui.device.k210MaixDock.description":
        "K210 RISC-V சிப்பை அடிப்படையாகக் கொண்ட அடிப்படை செயல்பாடுகள் மற்றும் அனைத்து IO பின்களும் வெளிப்படுத்தப்பட்ட போர்டு.",
    "gui.device.k210Maixduino.description": "ESP32 உடன் K210 RISC-V போர்டு.",
    "gui.device.raspberryPiPicoIconURL.description":
        "உங்கள் எலக்ட்ரானிக்ஸ் ஐடியாக்களுக்கு உயை உயிர்ப்பிக்க எளிதான மைக்ரோகன்ட்ரோலர் போர்டு.",
    "gui.device.raspberryPiPicoWIconURL.description":
        "உள்ளமை Wi-Fi மற்றும் Bluetooth 5.2 கொண்ட Pico, வயர்லெஸ் மற்றும் IoT திட்டங்களுக்கு ஏற்றது.",
    "gui.device.raspberryPiPico2IconURL.description":
        "போதுமான RAM மற்றும் ஃப்ளாஷ் கொண்ட உயர் செயல்திறன் டுவல்-கோர் MCU.",
    "gui.device.raspberryPiPico2WIconURL.description":
        "உள்ளமை 2.4 GHz Wi-Fi மற்றும் Bluetooth உடன் வயர்லெஸ் IoT மற்றும் ஸ்மார்ட்-ஹோம் ஒருங்கிணைப்புக்கு.",
    "gui.device.microbit.description":
        "பாக்கெட் அளவு கணினி டிஜிட்டல் திறன்களை மாற்றும்.",
    "gui.device.microbitV2.description":
        "மேம்பட்ட செயலி, உள்ளமை ஸ்பீக்கர் மற்றும் மைக்ரோஃபோன், டச் சென்சிட்டிவ் லோகோ.",
    "gui.device.makeymakey.description": "எதையும் ஒரு விசையாக மாற்று.",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.device.tifBot.description":
        "TIF-BOT என்பது Wi-Fi, Bluetooth மற்றும் ரோபோட்டிக்ஸ் மற்றும் IoT திட்டங்களுக்கான பல peripherals உடன் கூடிய ESP32-S3 அடிப்படையிலான போர்டு ஆகும்.",
    "gui.device.lightWingDrone.description":
        "லைட் விங் ட்ரோன் என்பது மேம்பட்ட ஸ்திரத்தன்மை மற்றும் Wi-Fi கட்டுப்பாட்டுடன் கூடிய உயர் செயல்திறன் ESP32-S3 அடிப்படையிலான ஃப்ளைட் கண்ட்ரோலர் ஆகும்.",
    "gui.device.roboticDog.description":
        "Robotic Dog என்பது Arduino Nano ஆல் இயக்கப்படும் ஒரு ஸ்மார்ட் நான்கு கால் ரோபோ ஆகும், இது உயிருள்ள போன்ற இயக்கங்கள் மற்றும் தடைகளைத் தவிர்க்கும் திறன் கொண்டது.",
    "gui.device.roboticArm.description":
        "Robotic Arm என்பது Arduino Nano ஆல் இயக்கப்படும் ஒரு பல-அச்சு மேனிபுலேட்டர் ஆகும், இது துல்லியமான பணிகள் மற்றும் ஆட்டோமேஷன் கற்றலுக்காக வடிவமைக்கப்பட்டுள்ளது.",
    // Music
    "music.categoryName": "இசை",
    "music.playDrumForBeats":
        "ட்ரம் [DRUM] [BEATS] துடிப்புகளுக்கு வாசிக்கவும்",
    "music.restForBeats": "[BEATS] துடிப்புகளுக்கு இடைவெளி விடவும்",
    "music.playNoteForBeats": "நோட் [NOTE] [BEATS] துடிப்புகளுக்கு வாசிக்கவும்",
    "music.setInstrument": "கருவி [INSTRUMENT] என அமைக்கவும்",
    "music.changeTempo": "டெம்போவை [TEMPO] ஆல் மாற்றவும்",
    "music.setTempo": "டெம்போவை [TEMPO] என அமைக்கவும்",
    "music.getTempo": "டெம்போ",
    "music.drumBass": "(2) பாஸ் ட்ரம்",
    "music.drumBongo": "(13) பொங்கோ",
    "music.drumCabasa": "(15) கபாசா",
    "music.drumClaves": "(9) கிளேவ்ஸ்",
    "music.drumClosedHiHat": "(6) க்ளோஸ்டு ஹை-ஹாட்",
    "music.drumConga": "(14) கொங்கா",
    "music.drumCowbell": "(11) கவ்பெல்",
    "music.drumCrashCymbal": "(4) கிராஷ் சிம்பல்",
    "music.drumCuica": "(18) குயிகா",
    "music.drumGuiro": "(16) கைரோ",
    "music.drumHandClap": "(8) கைதட்டல்",
    "music.drumOpenHiHat": "(5) ஓப்பன் ஹை-ஹாட்",
    "music.drumSideStick": "(3) சைட் ஸ்டிக்",
    "music.drumSnare": "(1) ஸ்னேர் ட்ரம்",
    "music.drumTambourine": "(7) தம்போரின்",
    "music.drumTriangle": "(12) ட்ரையாங்கிள்",
    "music.drumVibraslap": "(17) வைப்ராஸ்லாப்",
    "music.drumWoodBlock": "(10) வுட் பிளாக்",
    "music.instrumentBass": "(6) பாஸ்",
    "music.instrumentBassoon": "(14) பாஸூன்",
    "music.instrumentCello": "(8) செல்லோ",
    "music.instrumentChoir": "(15) பாடகர் குழு",
    "music.instrumentClarinet": "(10) கிளாரினெட்",
    "music.instrumentElectricGuitar": "(5) எலக்ட்ரிக் கிட்டார்",
    "music.instrumentElectricPiano": "(2) எலக்ட்ரிக் பியானோ",
    "music.instrumentFlute": "(12) புல்லாங்குழல்",
    "music.instrumentGuitar": "(4) கிட்டார்",
    "music.instrumentMarimba": "(19) மரிம்பா",
    "music.instrumentMusicBox": "(17) மியூசிக் பாக்ஸ்",
    "music.instrumentOrgan": "(3) ஆர்கன்",
    "music.instrumentPiano": "(1) பியானோ",
    "music.instrumentPizzicato": "(7) பிசிகாடோ",
    "music.instrumentSaxophone": "(11) சாக்ஸபோன்",
    "music.instrumentSteelDrum": "(18) ஸ்டீல் ட்ரம்",
    "music.instrumentSynthLead": "(20) சின்த் லீட்",
    "music.instrumentSynthPad": "(21) சின்த் பேட்",
    "music.instrumentTrombone": "(9) டிரோம்போன்",
    "music.instrumentVibraphone": "(16) வைப்ராபோன்",
    "music.instrumentWoodenFlute": "(13) மரப் புல்லாங்குழல்",

    // Pen
    "pen.categoryName": "பேனா",
    "pen.clear": "அனைத்தையும் அழிக்கவும்",
    "pen.stamp": "ஸ்டாம்ப்",
    "pen.penDown": "பேனாவைக் கீழே வைக்கவும்",
    "pen.penUp": "பேனாவை மேலே தூக்கவும்",
    "pen.setColor": "பேனா நிறத்தை [COLOR] என அமைக்கவும்",
    "pen.changeSize": "பேனா அளவை [SIZE] ஆல் மாற்றவும்",
    "pen.setSize": "பேனா அளவை [SIZE] என அமைக்கவும்",
    "pen.colorMenu.color": "நிறம்",
    "pen.colorMenu.saturation": "சாச்சுரேஷன்",
    "pen.colorMenu.brightness": "பிரகாசம்",
    "pen.colorMenu.transparency": "வெளிப்படைத்தன்மை",

    // Extension Library Names and Descriptions
    "gui.extension.music.name": "இசை",
    "gui.extension.music.description":
        "வாத்தியங்கள் மற்றும் டிரம்ஸை வாசிக்கவும்.",
    "gui.extension.pen.name": "பேனா",
    "gui.extension.pen.description": "உங்கள் ஸ்ப்ரைட்களைக் கொண்டு வரையவும்.",
    "gui.extension.videosensing.name": "வீடியோ சென்சிங்",
    "gui.extension.videosensing.description": "கேமரா மூலம் இயக்கத்தை உணரவும்.",
    "gui.extension.poseface.name": "முக உணர்தல்",
    "gui.extension.poseface.description": "கேமரா மூலம் முக அசைவுகளை உணரவும்.",
    "gui.extension.posehand.name": "கை உணர்தல்",
    "gui.extension.posehand.description": "கேமரா மூலம் கை அசைவுகளை உணரவும்.",
    "gui.extension.posebody.name": "உடல் தோரணை உணர்தல்",
    "gui.extension.posebody.description": "கேமரா மூலம் உடல் அசைவுகளை உணரவும்.",
    "gui.extension.teachablemachine.name": "கற்பிக்கக்கூடிய இயந்திரம்",
    "gui.extension.teachablemachine.description":
        "உங்கள் கேமரா மூலம் தனிப்பயன் இயந்திர கற்றல் மாதிரிகளைப் பயன்படுத்தவும்.",
    "gui.extension.text2speech.name": "உரையிலிருந்து பேச்சு",
    "gui.extension.text2speech.description": "உங்கள் திட்டங்களை பேச வைக்கவும்.",
    "gui.extension.translate.name": "மொழிபெயர்ப்பு",
    "gui.extension.translate.description":
        "உரையை பல மொழிகளில் மொழிபெயர்க்கவும்.",
    "gui.extension.makeymakey.name": "மேக்கி மேக்கி",
    "gui.extension.makeymakey.description":
        "எதையும் ஒரு விசையாக (Key) மாற்றவும்.",

    // Arduino Translations
    "arduinoUno.category.pins": "பின்கள்",
    "arduinoUno.category.serial": "சீரியல்",
    "arduinoUno.category.data": "தரவு",

    "arduinoNano.category.pins": "பின்கள்",
    "arduinoNano.category.serial": "சீரியல்",
    "arduinoNano.category.data": "தரவு",

    "arduinoLeonardo.category.pins": "பின்கள்",
    "arduinoLeonardo.category.serial": "சீரியல்",
    "arduinoLeonardo.category.data": "தரவு",

    "arduinoMega2560.category.pins": "பின்கள்",
    "arduinoMega2560.category.serial": "சீரியல்",
    "arduinoMega2560.category.data": "தரவு",

    "arduinoEsp32.category.pins": "பின்கள்",
    "arduinoEsp32.category.serial": "சீரியல்",
    "arduinoEsp32.category.data": "தரவு",

    "arduinoEsp8266.category.pins": "பின்கள்",
    "arduinoEsp8266.category.serial": "சீரியல்",
    "arduinoEsp8266.category.data": "தரவு",

    "arduinoK210.category.pins": "பின்கள்",
    "arduinoK210.category.serial": "சீரியல்",
    "arduinoK210.category.data": "தரவு",

    "arduinoRaspberryPiPico.category.pins": "பின்கள்",
    "arduinoRaspberryPiPico.category.serial": "சீரியல்",
    "arduinoRaspberryPiPico.category.data": "தரவு",

    // Arduino Uno Blocks
    "arduinoUno.modeMenu.input": "உள்ளீடு",
    "arduinoUno.modeMenu.output": "வெளியீடு",
    "arduinoUno.modeMenu.inputPullup": "உள்ளீடு-புல்அப்",
    "arduinoUno.levelMenu.high": "ஹை (High)",
    "arduinoUno.levelMenu.low": "லோ (Low)",
    "arduinoUno.pins.setPinMode": "பின் [PIN] மோட் [MODE] அமைக்கவும்",
    "arduinoUno.pins.setDigitalOutput":
        "டிஜிட்டல் பின் [PIN] வெளியீடு [LEVEL] அமைக்கவும்",
    "arduinoUno.pins.setPwmOutput": "PWM பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoUno.pins.readDigitalPin": "டிஜிட்டல் பின் [PIN] படிக்கவும்",
    "arduinoUno.pins.readAnalogPin": "அனலாக் பின் [PIN] படிக்கவும்",
    "arduinoUno.pins.setServoOutput":
        "சர்வோ பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoUno.pins.attachInterrupt":
        "இன்டரப்ட் பின் [PIN] மோட் [MODE] இணைக்கவும்",
    "arduinoUno.pins.detachInterrupt": "இன்டரப்ட் பின் [PIN] நீக்கவும்",
    "arduinoUno.serial.serialBegin": "சீரியல் தொடங்கவும் பாட்ரேட் [VALUE]",
    "arduinoUno.serial.serialPrint": "சீரியல் பிரிண்ட் [VALUE] [EOL]",
    "arduinoUno.serial.serialAvailable": "சீரியல் கிடைக்கும் தரவு நீளம்",
    "arduinoUno.serial.serialReadAByte": "சீரியல் ஒரு பைட் படிக்கவும்",
    "arduinoUno.data.dataMap":
        "[DATA]-ஐ ([ARG0], [ARG1])-லிருந்து ([ARG2], [ARG3])-க்கு மேப் செய்யவும்",

    // Arduino Nano Blocks
    "arduinoNano.modeMenu.input": "உள்ளீடு",
    "arduinoNano.modeMenu.output": "வெளியீடு",
    "arduinoNano.modeMenu.inputPullup": "உள்ளீடு-புல்அப்",
    "arduinoNano.levelMenu.high": "ஹை (High)",
    "arduinoNano.levelMenu.low": "லோ (Low)",
    "arduinoNano.pins.setPinMode": "பின் [PIN] மோட் [MODE] அமைக்கவும்",
    "arduinoNano.pins.setDigitalOutput":
        "டிஜிட்டல் பின் [PIN] வெளியீடு [LEVEL] அமைக்கவும்",
    "arduinoNano.pins.setPwmOutput": "PWM பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoNano.pins.readDigitalPin": "டிஜிட்டல் பின் [PIN] படிக்கவும்",
    "arduinoNano.pins.readAnalogPin": "அனலாக் பின் [PIN] படிக்கவும்",
    "arduinoNano.pins.setServoOutput":
        "சர்வோ பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoNano.pins.attachInterrupt":
        "இன்டரப்ட் பின் [PIN] மோட் [MODE] இணைக்கவும்",
    "arduinoNano.pins.detachInterrupt": "இன்டரப்ட் பின் [PIN] நீக்கவும்",
    "arduinoNano.serial.serialBegin": "சீரியல் தொடங்கவும் பாட்ரேட் [VALUE]",
    "arduinoNano.serial.serialPrint": "சீரியல் பிரிண்ட் [VALUE] [EOL]",
    "arduinoNano.serial.serialAvailable": "சீரியல் கிடைக்கும் தரவு நீளம்",
    "arduinoNano.serial.serialReadAByte": "சீரியல் ஒரு பைட் படிக்கவும்",
    "arduinoNano.data.dataMap":
        "[DATA]-ஐ ([ARG0], [ARG1])-லிருந்து ([ARG2], [ARG3])-க்கு மேப் செய்யவும்",

    // Arduino Leonardo Blocks
    "arduinoLeonardo.modeMenu.input": "உள்ளீடு",
    "arduinoLeonardo.modeMenu.output": "வெளியீடு",
    "arduinoLeonardo.modeMenu.inputPullup": "உள்ளீடு-புல்அப்",
    "arduinoLeonardo.levelMenu.high": "ஹை (High)",
    "arduinoLeonardo.levelMenu.low": "லோ (Low)",
    "arduinoLeonardo.pins.setPinMode": "பின் [PIN] மோட் [MODE] அமைக்கவும்",
    "arduinoLeonardo.pins.setDigitalOutput":
        "டிஜிட்டல் பின் [PIN] வெளியீடு [LEVEL] அமைக்கவும்",
    "arduinoLeonardo.pins.setPwmOutput":
        "PWM பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoLeonardo.pins.readDigitalPin": "டிஜிட்டல் பின் [PIN] படிக்கவும்",
    "arduinoLeonardo.pins.readAnalogPin": "அனலாக் பின் [PIN] படிக்கவும்",
    "arduinoLeonardo.pins.setServoOutput":
        "சர்வோ பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoLeonardo.pins.attachInterrupt":
        "இன்டரப்ட் பின் [PIN] மோட் [MODE] இணைக்கவும்",
    "arduinoLeonardo.pins.detachInterrupt": "இன்டரப்ட் பின் [PIN] நீக்கவும்",
    "arduinoLeonardo.serial.serialBegin": "சீரியல் தொடங்கவும் பாட்ரேட் [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "சீரியல் பிரிண்ட் [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialAvailable": "சீரியல் கிடைக்கும் தரவு நீளம்",
    "arduinoLeonardo.serial.serialReadAByte": "சீரியல் ஒரு பைட் படிக்கவும்",
    "arduinoLeonardo.data.dataMap":
        "[DATA]-ஐ ([ARG0], [ARG1])-லிருந்து ([ARG2], [ARG3])-க்கு மேப் செய்யவும்",

    // Arduino Mega2560 Blocks
    "arduinoMega2560.modeMenu.input": "உள்ளீடு",
    "arduinoMega2560.modeMenu.output": "வெளியீடு",
    "arduinoMega2560.modeMenu.inputPullup": "உள்ளீடு-புல்அப்",
    "arduinoMega2560.levelMenu.high": "ஹை (High)",
    "arduinoMega2560.levelMenu.low": "லோ (Low)",
    "arduinoMega2560.pins.setPinMode": "பின் [PIN] மோட் [MODE] அமைக்கவும்",
    "arduinoMega2560.pins.setDigitalOutput":
        "டிஜிட்டல் பின் [PIN] வெளியீடு [LEVEL] அமைக்கவும்",
    "arduinoMega2560.pins.setPwmOutput":
        "PWM பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoMega2560.pins.readDigitalPin": "டிஜிட்டல் பின் [PIN] படிக்கவும்",
    "arduinoMega2560.pins.readAnalogPin": "அனலாக் பின் [PIN] படிக்கவும்",
    "arduinoMega2560.pins.setServoOutput":
        "சர்வோ பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoMega2560.pins.attachInterrupt":
        "இன்டரப்ட் பின் [PIN] மோட் [MODE] இணைக்கவும்",
    "arduinoMega2560.pins.detachInterrupt": "இன்டரப்ட் பின் [PIN] நீக்கவும்",
    "arduinoMega2560.serial.serialBegin": "சீரியல் தொடங்கவும் பாட்ரேட் [VALUE]",
    "arduinoMega2560.serial.serialPrint": "சீரியல் பிரிண்ட் [VALUE] [EOL]",
    "arduinoMega2560.serial.serialAvailable": "சீரியல் கிடைக்கும் தரவு நீளம்",
    "arduinoMega2560.serial.serialReadAByte": "சீரியல் ஒரு பைட் படிக்கவும்",
    "arduinoMega2560.data.dataMap":
        "[DATA]-ஐ ([ARG0], [ARG1])-லிருந்து ([ARG2], [ARG3])-க்கு மேப் செய்யவும்",

    // Arduino ESP32 Blocks
    "arduinoEsp32.modeMenu.input": "உள்ளீடு",
    "arduinoEsp32.modeMenu.output": "வெளியீடு",
    "arduinoEsp32.modeMenu.inputPullup": "உள்ளீடு-புல்அப்",
    "arduinoEsp32.levelMenu.high": "ஹை (High)",
    "arduinoEsp32.levelMenu.low": "லோ (Low)",
    "arduinoEsp32.pins.setPinMode": "பின் [PIN] மோட் [MODE] அமைக்கவும்",
    "arduinoEsp32.pins.setDigitalOutput":
        "டிஜிட்டல் பின் [PIN] வெளியீடு [LEVEL] அமைக்கவும்",
    "arduinoEsp32.pins.setPwmOutput":
        "PWM பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoEsp32.pins.readDigitalPin": "டிஜிட்டல் பின் [PIN] படிக்கவும்",
    "arduinoEsp32.pins.readAnalogPin": "அனலாக் பின் [PIN] படிக்கவும்",
    "arduinoEsp32.pins.setServoOutput":
        "சர்வோ பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoEsp32.pins.attachInterrupt":
        "இன்டரப்ட் பின் [PIN] மோட் [MODE] இணைக்கவும்",
    "arduinoEsp32.pins.detachInterrupt": "இன்டரப்ட் பின் [PIN] நீக்கவும்",
    "arduinoEsp32.serial.serialBegin": "சீரியல் தொடங்கவும் பாட்ரேட் [VALUE]",
    "arduinoEsp32.serial.serialPrint": "சீரியல் பிரிண்ட் [VALUE] [EOL]",
    "arduinoEsp32.serial.serialAvailable": "சீரியல் கிடைக்கும் தரவு நீளம்",
    "arduinoEsp32.serial.serialReadAByte": "சீரியல் ஒரு பைட் படிக்கவும்",
    "arduinoEsp32.data.dataMap":
        "[DATA]-ஐ ([ARG0], [ARG1])-லிருந்து ([ARG2], [ARG3])-க்கு மேப் செய்யவும்",

    // Arduino ESP8266 Blocks
    "arduinoEsp8266.modeMenu.input": "உள்ளீடு",
    "arduinoEsp8266.modeMenu.output": "வெளியீடு",
    "arduinoEsp8266.modeMenu.inputPullup": "உள்ளீடு-புல்அப்",
    "arduinoEsp8266.levelMenu.high": "ஹை (High)",
    "arduinoEsp8266.levelMenu.low": "லோ (Low)",
    "arduinoEsp8266.pins.setPinMode": "பின் [PIN] மோட் [MODE] அமைக்கவும்",
    "arduinoEsp8266.pins.setDigitalOutput":
        "டிஜிட்டல் பின் [PIN] வெளியீடு [LEVEL] அமைக்கவும்",
    "arduinoEsp8266.pins.setPwmOutput":
        "PWM பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoEsp8266.pins.readDigitalPin": "டிஜிட்டல் பின் [PIN] படிக்கவும்",
    "arduinoEsp8266.pins.readAnalogPin": "அனலாக் பின் [PIN] படிக்கவும்",
    "arduinoEsp8266.pins.setServoOutput":
        "சர்வோ பின் [PIN] வெளியீடு [OUT] அமைக்கவும்",
    "arduinoEsp8266.pins.attachInterrupt":
        "இன்டரப்ட் பின் [PIN] மோட் [MODE] இணைக்கவும்",
    "arduinoEsp8266.pins.detachInterrupt": "இன்டரப்ட் பின் [PIN] நீக்கவும்",
    "arduinoEsp8266.serial.serialBegin": "சீரியல் தொடங்கவும் பாட்ரேட் [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "சீரியல் பிரிண்ட் [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialAvailable": "சீரியல் கிடைக்கும் தரவு நீளம்",
    "arduinoEsp8266.serial.serialReadAByte": "சீரியல் ஒரு பைட் படிக்கவும்",
    "arduinoEsp8266.data.dataMap":
        "[DATA]-ஐ ([ARG0], [ARG1])-லிருந்து ([ARG2], [ARG3])-க்கு மேப் செய்யவும்",
    // Additional Data Blocks
    "arduinoUno.data.dataConstrain":
        "[DATA]-ஐ ([ARG0], [ARG1])-க்கு இடையில் கட்டுப்படுத்து",
    "arduinoUno.data.dataConvert": "[DATA]-ஐ [TYPE]-ஆக மாற்றவும்",
    "arduinoUno.data.dataConvertASCIICharacter":
        "[DATA]-ஐ ASCII எழுத்து-ஆக மாற்றவும்",
    "arduinoUno.data.dataConvertASCIINumber": "[DATA]-ஐ ASCII எண்-ஆக மாற்றவும்",
    "arduinoUno.dataTypeMenu.integer": "முழு எண்",
    "arduinoUno.dataTypeMenu.decimal": "தசம",
    "arduinoUno.dataTypeMenu.string": "சரம்",

    "arduinoNano.data.dataConstrain":
        "[DATA]-ஐ ([ARG0], [ARG1])-க்கு இடையில் கட்டுப்படுத்து",
    "arduinoNano.data.dataConvert": "[DATA]-ஐ [TYPE]-ஆக மாற்றவும்",
    "arduinoNano.data.dataConvertASCIICharacter":
        "[DATA]-ஐ ASCII எழுத்து-ஆக மாற்றவும்",
    "arduinoNano.data.dataConvertASCIINumber":
        "[DATA]-ஐ ASCII எண்-ஆக மாற்றவும்",
    "arduinoNano.dataTypeMenu.integer": "முழு எண்",
    "arduinoNano.dataTypeMenu.decimal": "தசம",
    "arduinoNano.dataTypeMenu.string": "சரம்",

    "arduinoLeonardo.data.dataConstrain":
        "[DATA]-ஐ ([ARG0], [ARG1])-க்கு இடையில் கட்டுப்படுத்து",
    "arduinoLeonardo.data.dataConvert": "[DATA]-ஐ [TYPE]-ஆக மாற்றவும்",
    "arduinoLeonardo.data.dataConvertASCIICharacter":
        "[DATA]-ஐ ASCII எழுத்து-ஆக மாற்றவும்",
    "arduinoLeonardo.data.dataConvertASCIINumber":
        "[DATA]-ஐ ASCII எண்-ஆக மாற்றவும்",
    "arduinoLeonardo.dataTypeMenu.integer": "முழு எண்",
    "arduinoLeonardo.dataTypeMenu.decimal": "தசம",
    "arduinoLeonardo.dataTypeMenu.string": "சரம்",

    "arduinoMega2560.data.dataConstrain":
        "[DATA]-ஐ ([ARG0], [ARG1])-க்கு இடையில் கட்டுப்படுத்து",
    "arduinoMega2560.data.dataConvert": "[DATA]-ஐ [TYPE]-ஆக மாற்றவும்",
    "arduinoMega2560.data.dataConvertASCIICharacter":
        "[DATA]-ஐ ASCII எழுத்து-ஆக மாற்றவும்",
    "arduinoMega2560.data.dataConvertASCIINumber":
        "[DATA]-ஐ ASCII எண்-ஆக மாற்றவும்",
    "arduinoMega2560.dataTypeMenu.integer": "முழு எண்",
    "arduinoMega2560.dataTypeMenu.decimal": "தசம",
    "arduinoMega2560.dataTypeMenu.string": "சரம்",

    "arduinoEsp32.data.dataConstrain":
        "[DATA]-ஐ ([ARG0], [ARG1])-க்கு இடையில் கட்டுப்படுத்து",
    "arduinoEsp32.data.dataConvert": "[DATA]-ஐ [TYPE]-ஆக மாற்றவும்",
    "arduinoEsp32.data.dataConvertASCIICharacter":
        "[DATA]-ஐ ASCII எழுத்து-ஆக மாற்றவும்",
    "arduinoEsp32.data.dataConvertASCIINumber":
        "[DATA]-ஐ ASCII எண்-ஆக மாற்றவும்",
    "arduinoEsp32.dataTypeMenu.integer": "முழு எண்",
    "arduinoEsp32.dataTypeMenu.decimal": "தசம",
    "arduinoEsp32.dataTypeMenu.string": "சரம்",

    "arduinoEsp8266.data.dataConstrain":
        "[DATA]-ஐ ([ARG0], [ARG1])-க்கு இடையில் கட்டுப்படுத்து",
    "arduinoEsp8266.data.dataConvert": "[DATA]-ஐ [TYPE]-ஆக மாற்றவும்",
    "arduinoEsp8266.data.dataConvertASCIICharacter":
        "[DATA]-ஐ ASCII எழுத்து-ஆக மாற்றவும்",
    "arduinoEsp8266.data.dataConvertASCIINumber":
        "[DATA]-ஐ ASCII எண்-ஆக மாற்றவும்",
    "arduinoEsp8266.dataTypeMenu.integer": "முழு எண்",
    "arduinoEsp8266.dataTypeMenu.decimal": "தசம",
    "arduinoEsp8266.dataTypeMenu.string": "சரம்",

    // Library manager & Board manager
    "gui.librariesBoardsTab": "லைப்ரரிகள்",
    "gui.boardManagerTab": "போர்டு மேனேஜர்",

    "gui.boardManager.title": "போர்டு மேனேஜர்",
    "gui.boardManager.description":
        "அதிகாரப்பூர்வ Arduino போர்டுகளைத் தேடி நிறுவவும்.",
    "gui.boardManager.searchPlaceholder":
        "Arduino போர்டைத் தேடுங்கள் (எ.கா: esp32)",
    "gui.boardManager.search": "தேடுங்கள்",
    "gui.boardManager.searching": "தேடுகிறது...",
    "gui.boardManager.advancedOptionsShow":
        "▶ மேம்பட்ட விருப்பங்கள் (தனிப்பயன் நிறுவல் பாதை)",
    "gui.boardManager.advancedOptionsHide":
        "▼ மேம்பட்ட விருப்பங்களை மறைக்கவும்",
    "gui.boardManager.recommended": "பரிந்துரைக்கப்பட்ட",
    "gui.boardManager.installed": "நிறுவப்பட்டது ({count})",
    "gui.boardManager.searchResults": "தேடல் முடிவுகள் {count}",
    "gui.boardManager.refresh": "↻ புதுப்பி",
    "gui.boardManager.refreshing": "↻ புதுப்பிக்கப்படுகிறது...",

    "gui.libraryManager.title": "லைப்ரரி மேனேஜர்",
    "gui.libraryManager.description":
        "அதிகாரப்பூர்வ Arduino லைப்ரரிகளைத் தேடி நிறுவவும்.",
    "gui.libraryManager.searchPlaceholder":
        "Arduino லைப்ரரியைத் தேடுங்கள் (எ.கா: Servo)",
    "gui.libraryManager.search": "தேடுங்கள்",
    "gui.libraryManager.searching": "தேடுகிறது...",
    "gui.libraryManager.advancedOptionsShow":
        "▶ மேம்பட்ட விருப்பங்கள் (தனிப்பயன் நிறுவல் பாதை)",
    "gui.libraryManager.advancedOptionsHide":
        "▼ மேம்பட்ட விருப்பங்களை மறைக்கவும்",
    "gui.libraryManager.recommended": "பரிந்துரைக்கப்பட்ட",
    "gui.libraryManager.installed": "நிறுவப்பட்டது ({count})",
    "gui.libraryManager.searchResults": "தேடல் முடிவுகள் {count}",
    "gui.libraryManager.refresh": "↻ புதுப்பி",
    "gui.libraryManager.refreshing": "↻ புதுப்பிக்கப்படுகிறது...",
    "gui.gui.librariesBoardsTab": "நூலகங்கள்",
    "gui.gui.boardsManagerTab": "போர்டு மேனேஜர்",
};

export default ta;
